import styled from 'styled-components';

import { colorsV2 } from '../colors-v2';

export const QuestionContainer = styled.span`
  display: inline-flex;
  flex-flow: row wrap;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  margin: 4px;

  & > span:last-child {
    margin-right: 0;
  }

  .number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    margin-right: 8px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .answer {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    margin-right: 8px;
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
  }

  .text {
    font-size: 14px;
    font-weight: 400;
    color: ${colorsV2.black100};
  }

  &.default {
    .answer {
      background: ${colorsV2.gray10};
      color: ${colorsV2.black80};
    }
  }

  &.drag-into {
    .answer {
      background: ${colorsV2.blue20};
      color: ${colorsV2.blue100};
    }
  }

  &.filled {
    .answer {
      background: ${colorsV2.blue20};
      color: ${colorsV2.blue100};
    }
  }

  &.in-correct {
    .answer {
      background: ${colorsV2.red100};
      color: ${colorsV2.white100};
    }
    > .text {
      text-decoration: line-through;
    }
  }

  &.missed {
    .number {
      background: ${colorsV2.gray20};
      color: ${colorsV2.black100};
    }

    .answer {
      background: ${colorsV2.gray10};
      border: 1px dashed ${colorsV2.gray60};
      color: ${colorsV2.white100};
    }

    .text {
      color: ${colorsV2.yellow100};
    }
  }

  &.correct {
    .number {
      background: ${colorsV2.green100};
      color: ${colorsV2.white100};
    }

    .answer {
      background: ${colorsV2.gray20};
      border: none;
      color: ${colorsV2.black100};
    }

    > .text {
      text-decoration: none;
    }
  }

  &.empty {
    .answer {
      background: ${colorsV2.gray10};
      border: 1px dashed ${colorsV2.gray60};
    }
  }

  &.no-focus {
    .number {
      background: ${colorsV2.gray20};
      color: ${colorsV2.black100};
    }

    .answer {
      background: ${colorsV2.gray20};
      border: none;
      color: ${colorsV2.black100};
    }

    &.in-correct {
      .number {
        background: ${colorsV2.red20};
        color: ${colorsV2.red100};
      }
    }

    &.missed {
      .number {
        background: ${colorsV2.black100};
        color: ${colorsV2.white100};
      }
      .answer {
        background: ${colorsV2.gray10};
        border: 1px dashed ${colorsV2.black60};
        color: ${colorsV2.black100};
      }
    }

    &.correct {
      .number {
        background: ${colorsV2.green20};
        color: ${colorsV2.green100};
      }
    }

    &.empty {
      .answer {
        background: ${colorsV2.gray10};
        border: 1px dashed ${colorsV2.gray60};
      }
    }
  }
`;

export const Answer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 100%;
  margin-right: 8px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  &.default {
    background: ${colorsV2.gray10};
    border: 1px dashed ${colorsV2.gray60};
  }

  &.correct {
    background: ${colorsV2.green100};
    border: none;
    color: ${colorsV2.white100};
  }

  &.in-correct {
    background: ${colorsV2.red100};
    border: none;
    color: ${colorsV2.white100};
  }
`;
